module.exports = __webpack_public_path__ + "img/gu.af1f93d4.svg";